import { CalendarComponentOptions } from 'ion2-calendar';

import { ModalController } from 'ionic-angular/components/modal/modal-controller';

import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ActionSheetController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
import { ServisDuzenlePage } from '../servis-duzenle/servis-duzenle';
import { ServisHareketPage } from '../servis-hareket/servis-hareket';
import { ServisOdemeYapPage } from '../servis-odeme-yap/servis-odeme-yap';

import { ServisDetayPage } from '../servis-detay/servis-detay';
import { ServishareketdetayPage } from '../servishareketdetay/servishareketdetay';

/**
 * Generated class for the BekleyenListesiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-bekleyen-listesi',
  templateUrl: 'bekleyen-listesi.html',
})
export class BekleyenListesiPage {
  aranan = "";
  filter = false;
  hasta = "";
  aktifkullaniciyetkisi:"";
  aktifkullaniciid:number=0;
  skip: number = 0;
  take: number = 100;
  isListesi = [];
  check = false;
  gizle = 1;
  telno = "";
  sunucuadresi: any;
  tarih1: any;
  tarih2: any;
  numaralar: any = {};
  Tamamla:any={};
  Teslimet:any={};
  tarihAraligi: any;
  dateRange: {
    from: Date
    to: Date
  } = {
      from: this.tarih1,
      to: this.tarih2
    };
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  optionsRange: CalendarComponentOptions= {
    from: new Date(2018, 1, 1),
    pickMode: 'range',
    color: "danger"
  };

  @ViewChild('sideNavUrunAra') sideNav;
  @ViewChild('sideNavUrunAra2') sideNav2;

  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
   
    public actionSheetCtrl: ActionSheetController,
    public modalCtrl: ModalController,
    public navParams: NavParams) {
    this.sunucuadresi = this.ortak.storageSunucuAdresiGetir;
    this.tarih1 = this.ortak.tarih(this.ortak.storageGunTarihiGetir);
    this.tarih2 = this.tarih1;
    this.aktifkullaniciyetkisi=this.ortak.kullaniciType;
    this.aktifkullaniciid=this.ortak.storagePersonelGetir.ID;

  }

  ionViewDidLoad() {
    this.dateRange.from = this.ortak.storageGunTarihiGetir;
    this.dateRange.to = this.ortak.storageGunTarihiGetir;
    this.KayitAra2(null);
  }
  tarihhh() {
    this.tarih1 = new Date().toISOString();
    this.tarih2 = this.tarih1;
  }
  kayitAra(e) {
    var formData = new FormData();
    formData.append("tarih1", this.ortak.tarih(this.dateRange.from));
    formData.append("tarih2", this.ortak.tarih(this.dateRange.to));
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    formData.append("yetki",this.aktifkullaniciyetkisi.toString());
    formData.append("userid",this.aktifkullaniciid.toString());
    this.bllOrtak.islem(formData, "ParcaBekleyenListesi2", "", false).then(a => {
      var sonuc = <any>a;
      this.isListesi = sonuc.SonucObject;

    })
    this.closeNav();
  }
  KayitAra2(e) {

    var formData = new FormData();
    formData.append("aranan", this.aranan);

    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    formData.append("yetki",this.aktifkullaniciyetkisi.toString());
    formData.append("userid",this.aktifkullaniciid.toString());

    this.bllOrtak.islem(formData, "ParcaBekleyenListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.isListesi = sonuc.SonucObject;
     

    })
    this.closeNav2();
  }
  servisdetay(isler)
  {
    let modal = this.modalCtrl.create(ServisDetayPage, { vWKayit: isler }, { cssClass: "genisekran" });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();

  }


  iskayitlari(e) {
    if (e.keyCode == 13) {
      this.kayitAra(e);
    }
  }

  kayitduzenle(isler) {
    let modal = this.modalCtrl.create(ServisDuzenlePage, { vWKayit: isler }, { cssClass: "genisekran" });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
  }
  hareketDetay(isler) {
    let modal = this.modalCtrl.create(ServishareketdetayPage, { vWKayit: isler }, { cssClass: "genisekran" });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
  }
  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  openNav2() {
    let sideElement = this.sideNav2.nativeElement
    sideElement.style.display = "block";
  }
  hareketekle(isler) {
    if (isler.DurumID == 4) {
      this.ortak.showBasicAlert("Uyarı", "Teslim Edilmiş Bir Servis Kaydına Yeni Hareket Eklenemez");
    }
    else {
      let modal = this.modalCtrl.create(ServisHareketPage, { vWKayit: isler }, { cssClass: "genisekran" });
      modal.onDidDismiss(data => {
        this.ionViewDidLoad();
      });
      modal.present();

    }

  }
  closeNav() {
    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";
  }
  closeNav2() {
    let sideElement = this.sideNav2.nativeElement;
    sideElement.style.display = "none";
  }
  Islemler(isler) {
    const actionSheet = this.actionSheetCtrl.create({
      title: 'Servis  İşlemleri',
      buttons: [

        {
          text: 'Hareketler',
          handler: () => {
            this.hareketDetay(isler);
          }

        },
        {
          text: 'Hareket Ekle',
          handler: () => {
            this.hareketekle(isler);
          }

        },
        {
          text: 'Odeme Yap',
          handler: () => {
            this.odemeyap(isler);
          }

        }, {
          text: 'Düzenle',
          handler: () => {
            this.kayitduzenle(isler);
          }
        }, {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {

          }
        }
      ]
    });
    actionSheet.present();
  }
  odemeyap(isler) {
    let modal = this.modalCtrl.create(ServisOdemeYapPage, { vWKayit: isler }, { cssClass: "genisekran" });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
  }
  // ara(isler) {

  //   this.numaralar = isler;
  //   var formData = new FormData();
  //   formData.append("gidenkayit", JSON.stringify(this.numaralar));
  //   this.bllOrtak.islem(formData, "telnogetir", "", false).then(a => {
  //     var sonuc = <any>a;
  //     this.telno = sonuc.SonucObject;
  //     if (this.telno != null && this.telno != '') {
  //       this.call.callNumber(this.telno, true)
  //         .then(res => console.log('Launched dialer!', res))
  //         .catch(err => console.log('Error launching dialer', err));
  //     }
  //     else {
  //       this.ortak.showBasicAlert("UYARI", "Telefon numarası boş olamaz.");
  //     }

  //   })

  // }
  tamamla(isler)
  {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt Tamamlandı olarak değiştirilecektir. Devam etmek istiyor musunuz?").then(k => {  
    this.tamamla=isler;
    var formData = new FormData();
    formData.append("gidenkayit",JSON.stringify(this.tamamla));
    
    this.bllOrtak.islem(formData, "IsiTamamla", "", false).then(a => {
      var sonuc = <any>a;
      if(sonuc.Sonuc==1) this.ortak.showBasicAlert("Başarılı","İşlem Başarılı");
      this.KayitAra2(null);
    })
    this.KayitAra2(null);
  })
  this.KayitAra2(null);
}
  teslimet(isler)
  {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt Teslim Edildi olarak değiştirilecektir. Devam etmek istiyor musunuz?").then(k => { 
   
    this.Teslimet=isler;
    var formData = new FormData();
    formData.append("gidenkayit",JSON.stringify(this.Teslimet));
    
    this.bllOrtak.islem(formData, "IsiTeslimet", "", false).then(a => {
      var sonuc = <any>a;
      if(sonuc.Sonuc==1) this.ortak.showBasicAlert("Başarılı","İşlem Başarılı");
      this.KayitAra2(null);
      
    })
    this.KayitAra2(null);
  })
  this.KayitAra2(null);
  }
  goster()
  {

  }
  // smsgonder(isler) {
  //   let modal = this.modalCtrl.create(SmsGonderPage, { vWKayit: isler });
  //   modal.onDidDismiss(data => {
  //     this.ionViewDidLoad();
  //   });
  //   modal.present();
  // }
}



// WEBPACK FOOTER //
// ./src/pages/ServisKayit/bekleyen-listesi/bekleyen-listesi.ts